"use client";

import {
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
} from "@oreme/ui";
import { useAtom, useSetAtom } from "jotai";
import { navigationAtom, sidebarVisibilityAtom } from "@/store";
import { SidebarEnum } from "@/types";
import { useTranslations } from "next-intl";

function SharedMenubarViewSidebar() {
  const t = useTranslations("global.MenubarViewSidebar");
  const [navigation, setNavigation] = useAtom(navigationAtom);
  const toggleVisibility = useSetAtom(sidebarVisibilityAtom);

  const handleVelueChange = (value: string): void => {
    if (value === navigation) {
      setNavigation(null);
      toggleVisibility();
    } else {
      setNavigation(value as SidebarEnum);
      if (!navigation) toggleVisibility(true);
    }
  };

  return (
    <MenubarSub>
      <MenubarSubTrigger>{t("title")}</MenubarSubTrigger>
      <MenubarSubContent>
        <MenubarRadioGroup
          value={navigation!}
          onValueChange={handleVelueChange}
        >
          <MenubarRadioItem value="missions">{t("missions")}</MenubarRadioItem>
          <MenubarRadioItem value="sites">{t("sites")}</MenubarRadioItem>
        </MenubarRadioGroup>
      </MenubarSubContent>
    </MenubarSub>
  );
}

export { SharedMenubarViewSidebar };
